import * as moment from "moment";

export class InterviewsResourcesFakeDb {
  public static interviews = [
    {
      id: "rt5ertrgrgse",
      template: "Template 1",
      name: "Security Guard Questionnaire",
      status: "Completed",
      email: "even@gmail.com",
      description:
        "Invitation for interview. I need you to complete this interview form for us. Thanks!",
      updated: moment().format(),
    },
  ];

  public static formBuilderModel = {
    name: "Interview Resource",
    description:
      "bla bla bla bla bla bla bla bla bla bla bla bla bla bla " +
      "bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla " +
      "bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla " +
      "bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla " +
      "bla bla bla bla bla bla bla bla " +
      "bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla bla ",
    theme: {},
    sections: [
      {
        name: "Personal Details",
        description: "Some description for first section",
        id: "",
        conditional: {
          isConditional: false,
          conditionalText: "",
          conditionalValues: [
            {
              label: "yes",
              value: true,
            },
            {
              label: "no",
              value: false,
            },
          ],
        },
        attributes: [
          {
            type: "text",
            icon: "text_fields",
            label: "Name",
            description: "",
            placeholder: "Name",
            errorText: "Please enter a valid name",
            required: true,
            validation: true,
            regex: "",
          },
          {
            type: "phone",
            icon: "phone",
            label: "Phone",
            description: "Enter your phone number including country code",
            placeholder: "Phone",
            errorText: "Please enter a valid phone number",
            required: true,
            validation: true,
            regex: "",
          },
          {
            type: "email",
            icon: "alternate_email",
            required: true,
            label: "Email",
            description: "Enter a valid email address",
            placeholder: "Email",
            errorText: "Please enter a valid email",
            validation: true,
            regex: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
          },
          {
            type: "select",
            icon: "list",
            label: "Gender",
            description: "",
            placeholder: "Gender",
            errorText: "Please select one option",
            required: false,
            validation: true,
            values: [
              {
                label: "Option 1",
                value: "option-1",
              },
              {
                label: "Option 2",
                value: "option-2",
              },
              {
                label: "Option 3",
                value: "option-3",
              },
            ],
          },
          {
            type: "date",
            icon: "calendar_month",
            label: "Date of Birth",
            placeholder: "Date of Birth",
            errorText: "Please enter a valid date",
            required: true,
            validation: false,
            regex: "",
          },
        ],
      },
      {
        name: "Emergency Contact Details",
        description: "",
        id: "",
        conditional: {
          isConditional: false,
          conditionalText: "",
          conditionalValues: [
            {
              label: "yes",
              value: true,
            },
            {
              label: "no",
              value: false,
            },
          ],
        },
        attributes: [
          {
            type: "text",
            icon: "text_fields",
            label: "Contact Name",
            description: "",
            placeholder: "Contact Name",
            errorText: "Please enter a valid name",
            required: true,
            validation: true,
            regex: "",
          },
          {
            type: "phone",
            icon: "phone",
            label: "Contact Number",
            description: "Enter your phone number including country code",
            placeholder: "Contact Number",
            errorText: "Please enter a valid phone number",
            required: false,
            validation: true,
            regex: "",
          },
        ],
      },
      {
        name: "Do you speak other languages?",
        description: "",
        id: "",
        conditional: {
          isConditional: false,
          conditionalText: "",
          conditionalValues: [
            {
              label: "yes",
              value: true,
            },
            {
              label: "no",
              value: false,
            },
          ],
        },
        attributes: [
          {
            type: "radio",
            icon: "radio_button_checked",
            label: "",
            description: "",
            required: true,
            validation: false,
            values: [
              {
                label: "Yes",
                value: "option-1",
              },
              {
                label: "No",
                value: "option-2",
              },
            ],
          },
        ],
      },
      {
        name: "Availability",
        description: "",
        id: "",
        conditional: {
          isConditional: false,
          conditionalText: "",
          conditionalValues: [
            {
              label: "yes",
              value: true,
            },
            {
              label: "no",
              value: false,
            },
          ],
        },
        attributes: [
          {
            type: "checkbox",
            required: true,
            validation: false,
            label: "",
            icon: "check_box",
            description: "heckbox",
            inline: true,
            values: [
              {
                label: "Monday",
                value: "option-1",
                isChecked: false,
              },
              {
                label: "Tuesday",
                value: "option-2",
                isChecked: false,
              },
              {
                label: "Wednesday",
                value: "option-3",
                isChecked: false,
              },
              {
                label: "Thursday",
                value: "option-4",
                isChecked: false,
              },
              {
                label: "Friday",
                value: "option-5",
                isChecked: false,
              },
            ],
          },
        ],
      },
      {
        name: "Drivers Licence",
        description: "",
        id: "",
        conditional: {
          isConditional: false,
          conditionalText: "",
          conditionalValues: [
            {
              label: "yes",
              value: true,
            },
            {
              label: "no",
              value: false,
            },
          ],
        },
        attributes: [
          {
            type: "number",
            label: "Licence Number",
            icon: "dialpad",
            description: "",
            placeholder: "Licence Number",
            errorText: "Please enter a valid number",
            min: 0,
            max: "1000000",
            required: true,
            validation: false,
            regex: "",
          },
          {
            type: "datetime",
            icon: "calendar_month",
            label: "Expires At",
            placeholder: "Expires At",
            errorText: "Please enter a valid date and time",
            required: true,
            validation: false,
            regex: "",
          },
          {
            type: "time",
            icon: "schedule",
            label: "Random hour",
            placeholder: "Random hour",
            errorText: "Please enter a valid time",
            required: true,
            validation: false,
            regex: "",
          },
        ],
      },
      {
        name: "Rating Answers of the Interviews Resource",
        description: "",
        id: "",
        conditional: {
          isConditional: false,
          conditionalText: "",
          conditionalValues: [
            {
              label: "yes",
              value: true,
            },
            {
              label: "no",
              value: false,
            },
          ],
        },
        attributes: [
          {
            type: "rating",
            icon: "star",
            label: "1. What are the key tasks for a security guard?",
            required: false,
            validation: false,
            max: 5,
            regex: "",
          },
          {
            type: "rating",
            icon: "star",
            label:
              "2. Can you give me an example of a difficult situation you have dealt with?",
            required: false,
            validation: false,
            max: 5,
            regex: "",
          },
        ],
      },
      {
        name: "Additional Notes",
        description: "",
        id: "",
        conditional: {
          isConditional: false,
          conditionalText: "",
          conditionalValues: [
            {
              label: "yes",
              value: true,
            },
            {
              label: "no",
              value: false,
            },
          ],
        },
        attributes: [
          {
            type: "paragraph",
            icon: "short_text",
            label: "Observations",
            placeholder: "Type your text to display here only",
            required: false,
            validation: false,
            regex: "",
          },
          {
            type: "textarea",
            icon: "notes",
            label: "Textarea",
            required: false,
            validation: false,
            regex: "",
          },
        ],
      },
    ],
  }
}
